var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Zone "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("*")])], 1), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.zoneLoading
    },
    on: {
      "update:active": function($event) {
        _vm.zoneLoading = $event
      }
    }
  }), _vm._v(" "), _c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'error': _vm.errors.has('zone')
    },
    staticStyle: {
      "border": "1px solid #c2cfd6",
      "z-index": "999"
    },
    attrs: {
      "options": _vm.zoneList,
      "name": "zone",
      "id": "zone",
      "multiple": _vm.multiple(),
      "placeholder": "Select Zone",
      "label": "hubzonename",
      "track-by": "hubzoneid",
      "optionHeight": 100,
      "preselect-first": false,
      "hide-selected": true
    },
    on: {
      "input": _vm.addHubData
    },
    model: {
      value: (_vm.zone),
      callback: function($$v) {
        _vm.zone = $$v
      },
      expression: "zone"
    }
  }, [_c('template', {
    slot: "noResult"
  }, [_c('p', [_vm._v("No Record Found.")])])], 2)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('zone')),
      expression: "errors.has('zone')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Zone is required.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Hub / SVC")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.hubLoading
    },
    on: {
      "update:active": function($event) {
        _vm.hubLoading = $event
      }
    }
  }), _vm._v(" "), _c('Multiselect', {
    staticStyle: {
      "border": "1px solid #c2cfd6",
      "z-index": "999"
    },
    attrs: {
      "options": _vm.hubList,
      "placeholder": "Select Hub / SVC",
      "multiple": _vm.multipleHub(),
      "disabled": _vm.disableHub,
      "name": "HubId",
      "id": "HubId",
      "label": "HubName",
      "track-by": "HubID",
      "optionHeight": 100,
      "hide-selected": false
    },
    model: {
      value: (_vm.HubId),
      callback: function($$v) {
        _vm.HubId = $$v
      },
      expression: "HubId"
    }
  }, [_c('template', {
    slot: "noResult"
  }, [_c('p', [_vm._v("No Record Found.")])])], 2)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("RSC / SVC")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.RSCLoading
    },
    on: {
      "update:active": function($event) {
        _vm.RSCLoading = $event
      }
    }
  }), _vm._v(" "), _c('Multiselect', {
    staticStyle: {
      "border": "1px solid #c2cfd6",
      "z-index": "999"
    },
    attrs: {
      "options": _vm.RSCList,
      "placeholder": "Select RSC / SVC",
      "multiple": _vm.multipleRSC(),
      "disabled": _vm.disableHub,
      "name": "RSCName",
      "id": "RSCName",
      "label": "HubName",
      "track-by": "HubName",
      "optionHeight": 100,
      "hide-selected": false
    },
    model: {
      value: (_vm.RSCName),
      callback: function($$v) {
        _vm.RSCName = $$v
      },
      expression: "RSCName"
    }
  }, [_c('template', {
    slot: "noResult"
  }, [_c('p', [_vm._v("No Record Found.")])])], 2)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Delivery Date "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("*")])], 1), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "height": "45px"
    },
    attrs: {
      "left": "<i class='fa fa-calendar'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tilldate')
    },
    attrs: {
      "id": "tilldate",
      "type": "date",
      "name": "tilldate"
    },
    model: {
      value: (_vm.tilldate),
      callback: function($$v) {
        _vm.tilldate = $$v
      },
      expression: "tilldate"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tilldate')),
      expression: "errors.has('tilldate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Till date is required. ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._m(1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        _vm.resetForm()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Clear")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  Result\n\n                "), (_vm.exportf == false && _vm.resultCount > 0) ? _c('span', {
    staticStyle: {
      "margin-left": "70%"
    }
  }, [_c('font', {
    staticStyle: {
      "font-size": "12px",
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("Report available in few seconds..")])], 1) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exportf),
      expression: "exportf"
    }],
    staticStyle: {
      "margin-left": "85%",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.exportDisputeData()
      }
    }
  }, [_vm._m(2)])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(3), _vm._v(" "), _c('tbody', [(_vm.resultCount == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "8",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.DisputeReport), function(dispute, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.pageno + index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(dispute.Zone))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(dispute.HubName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(dispute.AWB))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(dispute.DeliveryDate))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(dispute.Amount))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(dispute.Reason) + "\n                      "), ((dispute.ReasonID == 363 || dispute.ReasonID == 165) && dispute.ReasonURL != undefined && dispute.ReasonURL != '') ? _c('a', {
      on: {
        "click": function($event) {
          _vm.generateUrl(dispute.ReasonURL)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-download",
      staticStyle: {
        "font-size": "15px",
        "color": "#4b8cbb",
        "margin": "0px 0px 0px 10px"
      },
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(dispute.SRName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(dispute.ClientName))])])
  })], 2)]), _c('br'), _vm._v(" "), (_vm.resultCount > 0) ? _c('paginate', {
    attrs: {
      "page-count": _vm.pagecount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '«',
      "next-text": '»',
      "container-class": 'pagination'
    }
  }) : _vm._e()], 1)])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header filter_main"
  }, [_c('i', {
    staticClass: " fa fa-filter filter"
  }), _vm._v(" Dispute Report\n          ")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Export")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("#")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Zone")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Hub/ SVC Name")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("AWB Number")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Delivery Date")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Dispute Amount ( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Dispute Reason")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("SR Name")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Client name")])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-85a5c65a","hasScoped":true}!./src/views/components/disputereport/disputereport.component.html
// module id = 731
// module chunks = 1